import type { common as pt } from '../pt-BR/common';
import type { Traducao } from '../Traducao';

export const common = {
  appName: 'My Update',
  yes: 'Yes',
  no: 'No',
  save: 'Save',
  cancel: 'Cancel',
  loading: 'Loading...',
  search: 'Search',
  searchPlaceholder: 'Type to search...',
  name: 'Name',
  status: 'Status',
  updatedAt: 'Updated at',
  statuses: {
    active: 'Active',
    inactive: 'Inactive',
  },
  errors: {
    required: 'Required field',
    invalidEmail: 'Invalid email',
    network: 'Connection failed. Please try again.',
  },
  data: {
    dia: 'Day',
    mes: 'Month',
    ano: 'Year',
    diaPlaceholder: 'dd',
    mesPlaceholder: 'mm',
    anoPlaceholder: 'yyyy',
  },
  nav: {
    sidebar: 'Sidebar',
    inicio: 'Home',
    campanhas: 'Campaigns',
    responder: 'Answer campaign',
    usuarios: 'Users and roles',
    language: 'Language',
    theme: 'Theme',
    userMenu: 'User menu',
  },
  themes: {
    light: 'Light',
    dark: 'Dark',
    system: 'System',
  },
  notFound: {
    title: 'Page not found',
    description: 'The page you are looking for does not exist or has been moved.',
    back: 'Back to home',
  },
  errorBoundary: {
    title: 'Something went wrong',
    description: 'An unexpected error occurred. Please reload the page and try again.',
    reload: 'Reload',
  },
  tableFilters: {
    trigger: 'Filter by {{column}}',
    triggerActive: 'Filter by {{column}} (filter applied)',
    title: 'Filter {{column}}',
    apply: 'Apply',
    clear: 'Clear',
    textPlaceholder: 'Contains…',
    textInputLabel: 'Text to filter {{column}}',
    optionsSearchPlaceholder: 'Search…',
    optionsSearchLabel: 'Search in {{column}}',
    optionsEmpty: 'Nothing found for "{{query}}".',
    min: 'Minimum',
    max: 'Maximum',
  },
  close: 'Close',
} as const satisfies Traducao<typeof pt>;
